import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirplane: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAirplane"><Path d="M19.3081 2C18.0483 2 16.8401 2.50044 15.9493 3.39124L13.344 5.99656L4.60792 2.91322L1.61414 5.907L8.2947 11.0459L7.06281 12.2778H5.00725L1.39453 15.8905L6.27703 17.7214L8.10797 22.6039L11.7207 18.9912V16.9357L12.9526 15.7038L18.0915 22.3843L21.0852 19.3905L18.0019 10.6544L20.6072 8.04913C21.498 7.15833 21.9985 5.95015 21.9985 4.69037V2H19.3081Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirplane;
